{
  "COMMUNITY_LESSON_NOT_FOUND": "Clase no encontrada",
  "GAMIFICATION_ACHIEVEMENT_NOT_FOUND": "Logro no encontrado",
  "GAMIFICATION_ACHIEVEMENT_DELETED": "Logro eliminado correctamente",
  "GAMIFICATION_LEVEL_ALREADY_EXISTS": "Este nivel ya existe",
  "GAMIFICATION_LEVEL_NOT_FOUND": "Nivel no encontrado",
  "GAMIFICATION_LEVEL_DELETED": "Nivel eliminado correctamente",
  "GAMIFICATION_BADGE_SHARE_LOGGED": "Se ha registrado que compartiste la insignia",
  "GAMIFICATION_WEEKLY_CHALLENGES_CREATED": "Retos semanales creados correctamente",
  "GAMIFICATION_MONTHLY_CHALLENGES_CREATED": "Retos mensuales creados correctamente",
  "GAMIFICATION_WEEKLY_LEADERBOARD_RESET": "Clasificación semanal reiniciada correctamente",
  "GAMIFICATION_EXPIRED_REWARDS_CLEANED": "Se han eliminado {{count}} recompensas vencidas",
  "GAMIFICATION_BROKEN_STREAKS_CLEANED": "Se han interrumpido {{count}} rachas",
  "GAMIFICATION_MONTHLY_FREEZES_RESET": "Congelaciones mensuales de racha reiniciadas correctamente",
  "STREAK_NOT_FOUND": "No se encontró ninguna racha",
  "STREAK_FREEZES_EXHAUSTED": "Ya usaste todas las congelaciones disponibles este mes",
  "STREAK_FREEZE_NOT_APPLICABLE": "La congelación solo se puede usar para evitar que se rompa la racha",
  "CHALLENGE_NOT_FOUND": "Reto no encontrado",
  "CHALLENGE_DELETED": "Reto eliminado correctamente",
  "CHALLENGE_NOT_ACTIVE": "El reto no está activo",
  "CHALLENGE_NOT_STARTED": "El reto todavía no ha empezado",
  "CHALLENGE_ENDED": "El reto ya ha terminado",
  "CHALLENGE_FULL": "El reto ya ha alcanzado el máximo de participantes",
  "CHALLENGE_ALREADY_JOINED": "Ya estás participando en este reto",
  "CHALLENGE_TEAM_REQUIRED": "Este reto requiere que formes parte de un equipo",
  "CHALLENGE_TEAM_INVALID": "Equipo no válido para este reto",
  "CHALLENGE_TEAM_NOT_ACCEPTING_MEMBERS": "Este equipo no acepta nuevos miembros",
  "CHALLENGE_TEAM_FULL": "Este equipo ya está completo",
  "CHALLENGE_PARTICIPATION_NOT_FOUND": "Participación en el reto no encontrada",
  "CHALLENGE_NOT_TEAM_BASED": "Este reto no es por equipos",
  "CHALLENGE_TEAM_NOT_FOUND": "Equipo no encontrado",
  "CHALLENGE_ALREADY_IN_TEAM": "Ya formas parte de un equipo en este reto",
  "CHALLENGE_TEAM_JOINED": "Te uniste al equipo correctamente",
  "REWARD_NOT_FOUND": "Recompensa no encontrada",
  "REWARD_DELETED": "Recompensa eliminada correctamente",
  "REWARD_UNAVAILABLE": "Esta recompensa ya no está disponible",
  "REWARD_EXPIRED": "Esta recompensa expiró",
  "REWARD_OUT_OF_STOCK": "Esta recompensa está agotada",
  "REWARD_INSUFFICIENT_XP": "Necesitas {{required}} XP para canjear esta recompensa. Tienes {{current}} XP.",
  "REWARD_REDEEMED_RECENTLY": "Ya canjeaste esta recompensa recientemente. Inténtalo de nuevo mañana.",
  "REWARD_REDEEMED": "¡Recompensa canjeada correctamente!",
  "REWARD_REDEMPTION_NOT_FOUND": "Canje no encontrado",
  "COMMENT_NOT_FOUND": "Comentario no encontrado",
  "COMMENT_LESSON_COMMENTS_DISABLED": "Esta clase no permite comentarios",
  "COMMENT_PARENT_NOT_FOUND": "Comentario principal no encontrado",
  "COMMENT_PARENT_LESSON_MISMATCH": "El comentario principal pertenece a otra clase",
  "COMMENT_EDIT_FORBIDDEN": "No puedes editar este comentario",
  "COMMENT_DELETE_FORBIDDEN": "No puedes eliminar este comentario",
  "COMMENT_PIN_FORBIDDEN": "No tienes permiso para fijar comentarios",
  "COMMENT_DELETED": "Comentario eliminado correctamente",
  "COMMENT_CONTENT_TOO_SHORT": "El comentario debe tener al menos 3 caracteres",
  "REACTION_ADDED": "Reacción añadida",
  "REACTION_REMOVED": "Reacción eliminada",
  "NOTIFICATION_NOT_FOUND": "Notificación no encontrada",
  "NOTIFICATION_ALL_MARKED_READ": "Todas las notificaciones se han marcado como leídas",
  "NOTIFICATION_DELETED": "Notificación eliminada",
  "SURVEY_NOT_FOUND": "Encuesta no encontrada",
  "SURVEY_NOT_ACTIVE": "La encuesta no está activa",
  "SURVEY_RESPONSE_LIMIT_REACHED": "La encuesta ha alcanzado el límite de respuestas",
  "SURVEY_ALREADY_ANSWERED": "Ya respondiste esta encuesta",
  "SURVEY_QUESTION_REQUIRED": "La pregunta \"{{question}}\" es obligatoria",
  "QUIZ_NOT_FOUND": "Cuestionario no encontrado",
  "QUIZ_ALREADY_TAKEN": "Ya hiciste esta evaluación",
  "QUIZ_MAX_RETRIES_EXCEEDED": "Se ha superado el máximo de {{max}} intentos",
  "QUIZ_ATTEMPT_NOT_FOUND": "Intento no encontrado",
  "QUIZ_ATTEMPT_FORBIDDEN": "El intento no pertenece al usuario",
  "QUIZ_ATTEMPT_ALREADY_FINISHED": "El intento ya ha finalizado",
  "CUSTOM_FIELD_NOT_FOUND": "Campo no encontrado",
  "COMMUNITY_NOT_CONFIGURED": "La integración con la comunidad no está configurada",
  "COMMUNITY_USER_NOT_FOUND": "Usuario no encontrado.",
  "COMMUNITY_AUTH_FAILED": "No se pudo iniciar sesión en la comunidad.",
  "COMMUNITY_SPACES_FETCH_FAILED": "No se pudieron listar los espacios de la comunidad.",
  "CIRCLE_CONFIG_SAVED": "Configuración de Circle guardada correctamente",
  "CIRCLE_TOKEN_NOT_CONFIGURED": "El token de la API de Circle no está configurado",
  "CIRCLE_API_ERROR": "La API de Circle ha devuelto un error ({{status}})",
  "CIRCLE_STATS_FETCH_FAILED": "No se pudieron obtener las estadísticas de Circle"
}
